import React from "react";

export const CardSkeleton = () => {
  return (
    <div className="animate-pulse rounded-[2rem] border border-slate-100 bg-white p-6 shadow-lg">
      <div className="flex items-center gap-3">
        <div className="w-14 h-14 rounded-2xl bg-slate-200" />

        <div className="flex-1">
          <div className="h-5 bg-slate-200 rounded w-40 mb-2" />
          <div className="h-4 bg-slate-100 rounded w-28" />
        </div>
      </div>

      <div className="mt-5 space-y-3">
        <div className="h-4 bg-slate-100 rounded w-full" />
        <div className="h-4 bg-slate-100 rounded w-5/6" />
        <div className="h-4 bg-slate-100 rounded w-4/6" />
      </div>

      <div className="mt-6 h-3 bg-slate-100 rounded-full w-full" />

      <div className="mt-6 flex justify-between">
        <div className="h-10 bg-slate-100 rounded-full w-32" />
        <div className="h-10 bg-slate-100 rounded-full w-24" />
      </div>
    </div>
  );
};

export const DetailSkeleton = () => {
  return (
    <div className="animate-pulse max-w-6xl mx-auto px-4 py-10">
      <div className="h-10 bg-slate-200 rounded w-1/3 mb-6" />

      <div className="rounded-3xl bg-white border border-slate-100 p-8 shadow-lg">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-20 h-20 rounded-3xl bg-slate-200" />

          <div className="flex-1">
            <div className="h-6 bg-slate-200 rounded w-48 mb-3" />
            <div className="h-4 bg-slate-100 rounded w-32" />
          </div>
        </div>

        <div className="space-y-4">
          <div className="h-4 bg-slate-100 rounded w-full" />
          <div className="h-4 bg-slate-100 rounded w-5/6" />
          <div className="h-4 bg-slate-100 rounded w-4/6" />
          <div className="h-4 bg-slate-100 rounded w-3/6" />
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
